import PassReviewPostGetRs from '@domain/rs/passReview/PassReviewPostGetRs';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  reviewData: PassReviewPostGetRs;
}

const Notice = ({ reviewData }: Props) => {
  if (!reviewData.contents) return null;

  return (
    <div
      className={cx('editor')}
      dangerouslySetInnerHTML={{
        __html: reviewData.contents,
      }}
    />
  );
};

export default Notice;
